/**
 * Values for UI that modifies UploadImage.duration.
 */
export const IMAGE_DURATION_MIN = 1;
export const IMAGE_DURATION_MAX = 60;
export const IMAGE_DURATION_DEFAULT = 20;



// WEBPACK FOOTER //
// ./src/mixins/imageDuration.js